const callbackName = "__recaptchaOnloadCallback";

function resolvedPromise() {
   return Promise.resolve();
}

let loadRecaptchaScript = (): Promise<void> => {
   const loadingCallbacks: (() => void)[] = [];

   window[callbackName] = () => {
      delete window[callbackName];
      loadRecaptchaScript = resolvedPromise;
      loadingCallbacks.forEach((resolve) => resolve());
   };

   const scriptElement = document.createElement("script");
   scriptElement.id = "recaptchaScript";
   scriptElement.async = true;
   scriptElement.src = `//www.google.com/recaptcha/enterprise.js?render=explicit&onload=${callbackName}`;
   document.body.appendChild(scriptElement);

   loadRecaptchaScript = () => {
      return new Promise<void>(resolve => loadingCallbacks.push(resolve));
   };

   return new Promise<void>((resolve) => {
      loadingCallbacks.push(resolve);
   });
}

export default () => loadRecaptchaScript();